import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { RocAssessmentQuestionnaireItem } from './questionnaire'
import { ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/adls-needs/questionnaireAnswer'
import { ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/assessment-overview/questionnaireAnswer'
import { SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/supervisory-review/questionnaireAnswer'
import { VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/visit-scheduling/questionnaireAnswer'
import { VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/vitals/questionnaireAnswer'
import { FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/final-steps'
import { RESUMPTION_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/resumption-overview/questionnaireAnswer'
import { MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/medical-background/questionnaireAnswer'
import { SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/skilled-needs/questionnaireAnswer'
import { DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/discharge-planning/questionnaireAnswer'
import { NARRATIVE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE } from '../sections/narrative/questionnaireAnswer'

export const ROC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE_OLD = {
  // Authorizations
  [RocAssessmentQuestionnaireItem.AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE]:
    QuestionnaireAnswerType.REFERENCE,
  [RocAssessmentQuestionnaireItem.AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS]:
    QuestionnaireAnswerType.DECIMAL,

  // Medications
  [RocAssessmentQuestionnaireItem.MEDICATIONS]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DRUGBANK_PCID]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_NAME]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_ROUTE]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_NUMBER]:
    QuestionnaireAnswerType.DECIMAL,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_STRENGTH_UNIT]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INDICATIONS]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_NUMBER]:
    QuestionnaireAnswerType.DECIMAL,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DOSAGE_UNIT]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INSTRUCTIONS]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_USAGE_STATUS]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_START_DATE]:
    QuestionnaireAnswerType.DATE,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_DISCONTINUE_DATE]:
    QuestionnaireAnswerType.DATE,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_CONTROLLED]:
    QuestionnaireAnswerType.BOOLEAN,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_LIQUID]:
    QuestionnaireAnswerType.BOOLEAN,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_LIST_MEDICATION_INFO_INFECTION]:
    QuestionnaireAnswerType.BOOLEAN,
  [RocAssessmentQuestionnaireItem.MEDICATIONS_MEDICATION_SUMMARY]: QuestionnaireAnswerType.STRING,

  // Skilled Needs
  [RocAssessmentQuestionnaireItem.SKILLED_NEEDS]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NAME]: QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_SCORE]: QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_NOTE]: QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.SKILLED_NEEDS_NEED_PREVIOUS_NOTE]: QuestionnaireAnswerType.STRING,

  // ADL Needs
  ...ADL_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,

  // Plan of Care
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_GOALS]: QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_GOALS_GOAL]: QuestionnaireAnswerType.INTEGER,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO]:
    QuestionnaireAnswerType.GROUP,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INTERVENTION]:
    QuestionnaireAnswerType.INTEGER,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_CATEGORY]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_GOAL]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TASK]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INDICATION]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_TYPE]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_INSTRUCTION]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_PATIENT_CENTERED_GOAL]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_ADDITIONAL_DETAILS]:
    QuestionnaireAnswerType.STRING,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_VISITS]:
    QuestionnaireAnswerType.INTEGER,
  [RocAssessmentQuestionnaireItem.PLAN_OF_CARE_PATIENT_INTERVENTIONS_INTERVENTION_INFO_FREQUENCY]:
    QuestionnaireAnswerType.STRING
}

// Amalgamate all section questionnaire answer type mappings
export const ROC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  ...ASSESSMENT_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...SUPERVISORY_REVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...VITALS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...VISIT_SCHEDULING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...DISCHARGE_PLANNING_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...ROC_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE_OLD,
  ...FINAL_STEPS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...RESUMPTION_OVERVIEW_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...MEDICAL_BACKGROUND_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...SKILLED_NEEDS_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE,
  ...NARRATIVE_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE
}
